import { render } from "./size-finder.vue?vue&type=template&id=183bc343"
import script from "./size-finder.vue?vue&type=script&lang=js"
export * from "./size-finder.vue?vue&type=script&lang=js"

import "./size-finder.vue?vue&type=style&index=0&id=183bc343&lang=scss"

import exportComponent from "/__w/dryrobe.com-website/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__